import { validateUserTokenApi } from './validateUserTokenApi';

export const { useValidateUserMutation } = validateUserTokenApi;

export { validateUserTokenApi };
